<nbl-report class="nbl-report">
  <report-header date="{ opts.date }"/>

  <div class="break-after" if="{ !opts.noMap }">
    <h1 class="ambita-report-h1">KART - Naboliste</h1>

    <p>
      Vedlagte liste (csv-fil) angir hjemmelshavere for den enkelte eiendom. I h.h.t. plan- og bygningsloven er det
      eiere og festere av nabo- og gjenboereiendommer som skal varsles. Eier er ikke alltid ensbetydende med
      hjemmelshaver. Det er ansvarlig søker/melder som er ansvarlig for å gjøre de nødvendige undersøkelser og sørge
      for at korrekt eier og fester varsles.
    </p>

    <table class="ambita-nbl-report__cadastre-info">
      <tr class="ambita-cadastre-info__row">
        <td class="ambita-cadastre-info__cell">
          <div class="ambita-cadastre-info-cell__title">Gnr:</div>
          <div class="ambita-cadastre-info-cell__value">{ opts.reportData.cadastre.gnr }</div>
        </td>

        <td class="ambita-cadastre-info__cell">
          <div class="ambita-cadastre-info-cell__title">Bnr:</div>
          <div class="ambita-cadastre-info-cell__value">{ opts.reportData.cadastre.bnr }</div>
        </td>

        <td class="ambita-cadastre-info__cell">
          <div class="ambita-cadastre-info-cell__title">Fnr:</div>
          <div class="ambita-cadastre-info-cell__value">{ opts.reportData.cadastre.fnr }</div>
        </td>

        <td class="ambita-cadastre-info__cell">
          <div class="ambita-cadastre-info-cell__title">Snr:</div>
          <div class="ambita-cadastre-info-cell__value">{ opts.reportData.cadastre.snr }</div>
        </td>
      </tr>
      <tr class="ambita-cadastre-info__row">
        <td class="ambita-cadastre-info__cell" colspan="2">
          <div class="ambita-cadastre-info-cell__title--colspan">Kommune:</div>
          <div class="ambita-cadastre-info-cell__value">
            { opts.reportData.municipality.name } ({ opts.reportData.county.name })
          </div>
        </td>

        <td class="ambita-cadastre-info__cell" colspan="2">
          <div class="ambita-cadastre-info-cell__title--colspan">Adresse:</div>
          <div class="ambita-cadastre-info-cell__value">
            { opts.reportData.address.title}, { opts.reportData.address.postcode} { opts.reportData.address.city}
          </div>
        </td>
      </tr>
    </table>

    <report-map config="{ opts.mapConfig }" task="{ opts.mapTask }"/>
  </div>

  <h1 class="ambita-report-h1">Kvittering for nabovarsel</h1>
  <p>Sendes kommunen sammen med søknaden</p>
  <p class="text-highlight">
    Nabovarsel kan enten sendes som rekommandert sending, overleveres personlig mot kvittering eller sendes
    på e-post mot kvittering. Med kvittering for mottatt e-post menes en e-post fra nabo/gjenboer
    som bekrefter å ha mottatt nabovarselet. Ved personlig overlevering vil signatur gjelde som
    bekreftelse på at varslet er mottatt. Det kan også signeres på at man gir samtykke til tiltaket
  </p>

  <nbl-applies-to cadastre="{ opts.reportData.cadastre }" address="{ opts.reportData.address }"></nbl-applies-to>
  <br>

  <p class="ambita-nbl-report__notificationFormLabel">
    Følgende naboer har mottatt eller fått rek. sendig av vedlagte nabovarsel med tilhørende vedlegg:
  </p>

  <nbl-notification-form each="{ neighbor in opts.reportData.neighbors }" neighbor="{ neighbor }">
  </nbl-notification-form>

  <div class="ambita-nbl-report__signature break-avoid">
    <div class="ambita-nbl-report__signatureText">
      Det er per dags dato innlevert rekommandert<br>
      sending til ovennevnte adressater.<br>
      <br><br>
      Samlet antall sendinger: __________ Sign.
    </div>
    <div class="ambita-nbl-report__signatureStamp">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
        <circle cx="50" cy="50" r="50" fill="none" stroke="#000000" stroke-width="1"></circle>
      </svg>
    </div>
  </div>

  <nbl-personal-form each="{ neighbor in opts.reportData.neighbors }"
                     neighbor="{ neighbor }"
                     address="{ parent.opts.reportData.address }"
                     cadastre="{ parent.opts.reportData.cadastre }"
                     owner="{ parent.opts.reportData.owner }"
                     prefill-schema="{ parent.opts.reportData.orderData.neighborListSchema }"/>

  <nbl-municipality-form address="{ opts.reportData.address }"
                         cadastre="{ opts.reportData.cadastre }"
                         owner="{ opts.reportData.owner }"
                         prefill-schema="{ opts.reportData.orderData.neighborListSchema }"/>

  <nbl-information />

  <script>
    import '../common/reportHeader.tag';
    import '../reportMap/reportMap.tag';
    import './neighborListNotificationForm.tag';
    import './neighborListPersonalForm.tag';
    import './neighborListAppliesTo.tag';
    import './neighborListInformation.tag';
    import './neighborListMunicipalityForm.tag';
    import './neighborListReport.scss';
  </script>
</nbl-report>
